import React from 'react';
import { 
  Box, 
  Typography, 
  Card, 
  CardContent, 
  Paper, 
  Grid,
  Container,
  Divider
} from '@mui/material';
import { Visibility, Flag, TrendingUp, EmojiObjects } from '@mui/icons-material';

const MisionVision = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Header */}
      <Box textAlign="center" mb={6}>
        <Typography variant="h3" color="primary" fontWeight="bold" gutterBottom>
          Misión y Visión
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 700, mx: 'auto' }}>
          Los pilares fundamentales que guían nuestro compromiso con la excelencia
        </Typography>
      </Box>

      {/* Misión y Visión Cards */}
      <Grid container spacing={4} mb={6}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Paper 
            elevation={0}
            sx={{ 
              p: 3, 
              borderRadius: 3, 
              background: 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)',
              color: 'white',
              height: '100%', boxSizing: 'border-box',
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              overflow: 'hidden',
              transition: 'all 0.3s ease',
              border: '2px solid transparent',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: '0 12px 24px rgba(44, 62, 80, 0.3)',
                border: '2px solid rgba(255, 255, 255, 0.2)'
              }
            }}
          >
            {/* Decorative Circle */}
            <Box
              sx={{
                position: 'absolute',
                top: -30,
                right: -30,
                width: 120,
                height: 120,
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.05)',
                zIndex: 0
              }}
            />
            
            <Box sx={{ position: 'relative', zIndex: 1 }}>
              <Box 
                sx={{ 
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  p: 1.5,
                  mb: 2,
                  borderRadius: 2,
                  background: 'rgba(255, 255, 255, 0.2)',
                  backdropFilter: 'blur(10px)'
                }}
              >
                <Flag sx={{ fontSize: 36 }} />
              </Box>
              
              <Typography variant="h4" fontWeight="bold" mb={2} sx={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                Misión
              </Typography>
              
              <Typography variant="body1" sx={{ lineHeight: 1.7, opacity: 0.95, fontWeight: 400 }}>
                Brindar soluciones integrales de ingeniería y consultoría de clase mundial, 
                impulsando la innovación y el desarrollo sostenible de nuestros clientes 
                a través de tecnología de vanguardia y un equipo altamente especializado.
              </Typography>
            </Box>
          </Paper>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Paper 
            elevation={0}
            sx={{ 
              p: 3, 
              borderRadius: 3, 
              background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
              color: 'white',
              height: '100%', boxSizing: 'border-box',
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              overflow: 'hidden',
              transition: 'all 0.3s ease',
              border: '2px solid transparent',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: '0 12px 24px rgba(25, 118, 210, 0.3)',
                border: '2px solid rgba(255, 255, 255, 0.2)'
              }
            }}
          >
            {/* Decorative Circle */}
            <Box
              sx={{
                position: 'absolute',
                top: -30,
                right: -30,
                width: 120,
                height: 120,
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.05)',
                zIndex: 0
              }}
            />
            
            <Box sx={{ position: 'relative', zIndex: 1 }}>
              <Box 
                sx={{ 
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  p: 1.5,
                  mb: 2,
                  borderRadius: 2,
                  background: 'rgba(255, 255, 255, 0.2)',
                  backdropFilter: 'blur(10px)'
                }}
              >
                <Visibility sx={{ fontSize: 36 }} />
              </Box>
              
              <Typography variant="h4" fontWeight="bold" mb={2} sx={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                Visión
              </Typography>
              
              <Typography variant="body1" sx={{ lineHeight: 1.7, opacity: 0.95, fontWeight: 400 }}>
                Ser la empresa líder en soluciones de ingeniería en América Latina, 
                reconocida por nuestra excelencia técnica, innovación constante y 
                compromiso inquebrantable con el desarrollo sostenible.
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>

      {/* Objetivos Estratégicos */}
      <Paper elevation={6} sx={{ p: 4, borderRadius: 4, mb: 6 }}>
        <Typography variant="h4" color="primary" fontWeight="bold" textAlign="center" gutterBottom>
          Objetivos Estratégicos
        </Typography>
        <Divider sx={{ mb: 4, bgcolor: 'primary.main', height: 2 }} />
        
        <Grid container spacing={4} sx={{ alignItems: 'stretch', justifyContent: 'center' }}>
          <Grid size={{ xs: 12, md: 4 }} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Card 
              elevation={3} 
              sx={{ 
                p: 3, 
                textAlign: 'center', 
                borderRadius: 3, 
                width: '100%',
                maxWidth: 350,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}
            >
              <Box>
                <TrendingUp sx={{ fontSize: 56, color: 'primary.main', mb: 2 }} />
                <Typography variant="h6" fontWeight="bold" gutterBottom color="primary">
                  Crecimiento Sostenible
                </Typography>
              </Box>
              <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7, mt: 2 }}>
                Expandir nuestra presencia en el mercado manteniendo los más altos 
                estándares de calidad y responsabilidad ambiental.
              </Typography>
            </Card>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Card 
              elevation={3} 
              sx={{ 
                p: 3, 
                textAlign: 'center', 
                borderRadius: 3, 
                width: '100%',
                maxWidth: 350,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}
            >
              <Box>
                <EmojiObjects sx={{ fontSize: 56, color: 'primary.main', mb: 2 }} />
                <Typography variant="h6" fontWeight="bold" gutterBottom color="primary">
                  Innovación Continua
                </Typography>
              </Box>
              <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7, mt: 2 }}>
                Desarrollar e implementar tecnologías de vanguardia que revolucionen 
                la industria de la ingeniería y consultoría.
              </Typography>
            </Card>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Card 
              elevation={3} 
              sx={{ 
                p: 3, 
                textAlign: 'center', 
                borderRadius: 3, 
                width: '100%',
                maxWidth: 350,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}
            >
              <Box>
                <Flag sx={{ fontSize: 56, color: 'primary.main', mb: 2 }} />
                <Typography variant="h6" fontWeight="bold" gutterBottom color="primary">
                  Excelencia Operacional
                </Typography>
              </Box>
              <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7, mt: 2 }}>
                Mantener los más altos estándares de calidad en todos nuestros 
                procesos y servicios, superando las expectativas del cliente.
              </Typography>
            </Card>
          </Grid>
        </Grid>
      </Paper>

      {/* Compromisos */}
      <Paper 
        elevation={6} 
        sx={{ 
          p: 4, 
          borderRadius: 4, 
          background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
        }}
      >
        <Typography variant="h4" color="primary" fontWeight="bold" textAlign="center" gutterBottom>
          Nuestros Compromisos
        </Typography>
        <Divider sx={{ mb: 4, bgcolor: 'primary.main', height: 2 }} />
        
        <Box sx={{ maxWidth: 1000, mx: 'auto' }}>
          <Grid container spacing={4}>
            {/* Columna Izquierda */}
            <Grid size={{ xs: 12, md: 6 }}>
              <Box display="flex" alignItems="center" mb={3}>
                <Box 
                  sx={{ 
                    width: 12, 
                    height: 12, 
                    borderRadius: '50%', 
                    bgcolor: 'primary.main', 
                    mr: 2,
                    flexShrink: 0
                  }} 
                />
                <Typography variant="h6" color="text.primary" fontWeight="500">
                  Calidad sin compromisos en cada proyecto
                </Typography>
              </Box>
              
              <Box display="flex" alignItems="center" mb={3}>
                <Box 
                  sx={{ 
                    width: 12, 
                    height: 12, 
                    borderRadius: '50%', 
                    bgcolor: 'primary.main', 
                    mr: 2,
                    flexShrink: 0
                  }} 
                />
                <Typography variant="h6" color="text.primary" fontWeight="500">
                  Innovación constante en nuestras soluciones
                </Typography>
              </Box>
              
              <Box display="flex" alignItems="center">
                <Box 
                  sx={{ 
                    width: 12, 
                    height: 12, 
                    borderRadius: '50%', 
                    bgcolor: 'primary.main', 
                    mr: 2,
                    flexShrink: 0
                  }} 
                />
                <Typography variant="h6" color="text.primary" fontWeight="500">
                  Desarrollo profesional de nuestro equipo
                </Typography>
              </Box>
            </Grid>
            
            {/* Columna Derecha */}
            <Grid size={{ xs: 12, md: 6 }}>
              <Box display="flex" alignItems="center" mb={3}>
                <Box 
                  sx={{ 
                    width: 12, 
                    height: 12, 
                    borderRadius: '50%', 
                    bgcolor: 'primary.main', 
                    mr: 2,
                    flexShrink: 0
                  }} 
                />
                <Typography variant="h6" color="text.primary" fontWeight="500">
                  Responsabilidad social y ambiental
                </Typography>
              </Box>
              
              <Box display="flex" alignItems="center" mb={3}>
                <Box 
                  sx={{ 
                    width: 12, 
                    height: 12, 
                    borderRadius: '50%', 
                    bgcolor: 'primary.main', 
                    mr: 2,
                    flexShrink: 0
                  }} 
                />
                <Typography variant="h6" color="text.primary" fontWeight="500">
                  Transparencia en todas nuestras operaciones
                </Typography>
              </Box>
              
              <Box display="flex" alignItems="center">
                <Box 
                  sx={{ 
                    width: 12, 
                    height: 12, 
                    borderRadius: '50%', 
                    bgcolor: 'primary.main', 
                    mr: 2,
                    flexShrink: 0
                  }} 
                />
                <Typography variant="h6" color="text.primary" fontWeight="500">
                  Satisfacción total del cliente
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Container>
  );
};

export default MisionVision;
